<template>
  <LoadingLine title="Danh sách đang được tổng kết" :count="period.progress" />
</template>
<script>
import { mapActions, mapState } from 'vuex'
import LoadingLine from '@/components/basic/LoadingLine.vue'
export default {
  components: {
    LoadingLine
  },
  created() {
    this.getPeriod()
  },
  computed: {
    ...mapState('tuitionFeePeriod', ['period', 'typeGroup'])
  },
  methods: {
    ...mapActions('tuitionFeePeriod', ['fetchPeriod']),
    getPeriod() {
      if (this.period.status === 'running') {
        this.interval = setInterval(() => {
          this.fetchPeriod(this.$route.params.id)
        }, 1000)
      }
    }
  },
  beforeDestroy() {
    clearInterval(this.interval)
  }
}
</script>
